import { useEffect } from 'react';
import styled from 'styled-components';

import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import { PaymentProviders } from '@/enums';
import { useAppDispatch } from '@/redux/hooks';
import { openAddCreditCardModal } from '@/redux/modules/modal';

import AddCreditCardPageHeaderMeta from './AddCreditCardPageHeaderMeta';

const AddCreditCardPage = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(openAddCreditCardModal(PaymentProviders.Payrix));
    }, [dispatch]);

    return (
        <EnsureLoggedInContainer>
            <StyledPageContainer>
                <AddCreditCardPageHeaderMeta />
            </StyledPageContainer>
        </EnsureLoggedInContainer>
    );
};

export default AddCreditCardPage;

const StyledPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
`;
